export function CreateIWizFilter(iWizData) {
  var doFilter = iWizData.GetFilterData();
  var theFilter = null;
  if (doFilter) {
    theFilter = iWizData.GetFilterRule();
  }

  return theFilter;
}
